module.exports = __webpack_public_path__ + "img/45.a086d8ba.png";